/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.8.1",
  "gitBuildTime": "2025-12-10T12:48:42.495Z",
  "gitBuildVersion": "2.8.1",
  "gitCommitId": "757c394",
  "gitCommitIdFull": "757c394193c5e609a394f589d1c0f21da154ddc4",
  "gitCommitTime": "2025-12-10T12:37:28.000Z",
  "version": "2.8.1-2025-12-10T12:37:28.000Z-(757c394)"
};
